<button
  mat-button
  type="button"
  [class.prerelease]="display === 'prerelease'"
  [class.build]="display === 'build'"
  [title]="'v' + appVersion + ' — click to copy'"
  (click)="copy()"
>
  @if (copied()) {
    <span class="line">copied</span>
  } @else if (display === "build" && parsed) {
    <span class="line">v{{ parsed.base }}</span>
    <span class="line">{{ parsed.prerelease }}</span>
  } @else {
    <span class="line">v{{ appVersion }}</span>
  }
</button>
